import { render } from "./emptyLayout.vue?vue&type=template&id=bfc47e0c&ts=true"
import script from "./emptyLayout.vue?vue&type=script&lang=ts"
export * from "./emptyLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__